import React from 'react'
import { Link } from 'react-router-dom'
import { features } from '../../content/csp'

const ClickHandler = () => {
  window.scrollTo(10, 0)
}

const PlatformPreview = () => {
  return (
    <section className="csp-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <span className="csp-kicker">CSPNow</span>
            <h2 className="csp-title">
              A web and mobile platform for discussion, polls, and documents.
            </h2>
            <p className="csp-lead">
              Members work inside Circles. The tools already exist. The work is
              using them so the center can be heard without turning every
              conversation into a fight.
            </p>
          </div>
        </div>
        <div className="csp-grid csp-grid--2" style={{ marginTop: 40 }}>
          {features.slice(0, 4).map((feature) => (
            <article className="csp-card" key={feature.id}>
              <h3>{feature.title}</h3>
              <p>{feature.text}</p>
            </article>
          ))}
        </div>
        <Link onClick={ClickHandler} className="csp-more" to="/platform">
          See the full platform
        </Link>
      </div>
    </section>
  )
}

export default PlatformPreview
